<template>
  <Main>
    <section
      id="report-container"
      ref="reportcontainer"
      class="resp-pbicontainer"
    ></section>
    <section class="error-container m-5"></section>
  </Main>
</template>
<script>
import { mapActions } from "vuex";
import { api } from "@/api";
import * as pbi from "powerbi-client";
export default {
  data: () => ({
    embedinfo: null
  }),
  mounted() {
    this.hasLoading(true);
    this.loadReport();
  },
  methods: {
    ...mapActions(["hasLoading"]),
    loadReport() {
      let hasloading = this.hasLoading;
      api.get(`/v1/dashboard/getembedinfo`).then(data => {
        this.embedinfo = data;

        if (this.embedinfo !== null) {
          var models = pbi.models;
          var reportContainer = this.$refs.reportcontainer;

          var reportLoadConfig = {
            type: "report",
            tokenType: models.TokenType.Embed,
            accessToken: this.embedinfo.data.embed_token.token,
            embedUrl: this.embedinfo.data.embed_report[0].embed_url,
            datasetBinding: {
              datasetId: this.embedinfo.data.datasetid
            },
            settings: {
              background: models.BackgroundType.Transparent
            }
          };

          let powerbi = new pbi.service.Service(
            pbi.factories.hpmFactory,
            pbi.factories.wpmpFactory,
            pbi.factories.routerFactory
          );

          var report = powerbi.embed(reportContainer, reportLoadConfig);

          // Clear any other loaded handler events
          report.off("loaded");

          // Triggers when a report schema is successfully loaded
          report.on("loaded", function() {
            console.log("Report load successful");
            hasloading(false);
          });

          // Clear any other rendered handler events
          report.off("rendered");

          // Triggers when a report is successfully embedded in UI
          report.on("rendered", function() {
            console.log("Report render successful");
          });

          // Clear any other error handler events
          report.off("error");

          // Handle embed errors
          report.on("error", function(event) {
            var errorMsg = event.detail;
            // Use errorMsg variable to log error in any destination of choice
            console.error(errorMsg);
            hasloading(false);
            return;
          });
        } else {
          console.error("Embed info was null.");
          hasloading(false);
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
.resp-pbicontainer {
  position: absolute;
  top: 65px;
  left: 0;
  width: 100%;
  height: calc(100% - 65px);
  border: 0;
}
</style>
